const env = "uat" || 'test';

const IMG_PRE_URL = {
  'dev': 'https://static.xyb2b.com/jdx-home/images',
  'test': 'https://static.xyb2b.com/jdx-home/images',
  'uat': 'https://static.xyb2b.com/jdx-home/images',
  'prod': 'https://file.bilionpass.com/images',
}[env] as string;


const LANG_URL = "production" ==='development' ? `http://${window.location.host}/i18n/web/latest/` : 'https://file.bilionpass.com/i18n/web/latest/'

const TOKEN_KEY = 'ACCESS_TOKEN'
const BUYER_INFO_KEY = 'BUYER_INFO'

const I18N_STORAGE_KEY = 'i18n_lang'

const API_PRE_URL = {
  'dev': 'http://api.test.jdx.xyb2b.cn',
  'test': 'https://api.test.jdx.xyb2b.cn',
  'uat':  'https://api.uat.jdx.xyb2b.com',
  'prod': 'https://api.bilionpass.com',
}[env] as string

const JAPAN_MALL_URL =  {
  test: 'https://developer.japanmall.com',
  uat: 'https://developer.japanmall.com',
  prod: 'https://www.japanmall.com',
}[env] as string;
const JAPAN_MALL_ORDER_URL = `${JAPAN_MALL_URL}/orderDetail?id={{id}}`

const VIP_URL = {
  test: 'https://vip-dev.japanmall.com/?fc=1111&sc=2222',
  uat: 'https://vip-dev.japanmall.com/?fc=1111&sc=2222',
  prod: 'https://vip.japanmall.com/?fc=DHtest&sc=0001',
}[env] as string;
const VIP_ORDER_URL = `${VIP_URL}#/pages/order/detail/index?id={{id}}`

const SAGAWA_URL = {
  test: 'https://h5-test.jdx.xyb2b.com',
  uat: 'https://h5-uat.jdx.xyb2b.com',
  // uat: 'https://h5-uat.sgw-jptrip.co.jp',
  prod: 'https://h5.sgw-jptrip.co.jp',
}[env] as string  
const SAGAWA_ORDER_URL = `${SAGAWA_URL}/#/pages/order/index?id={{id}}`

export {
  env,
  API_PRE_URL,
  IMG_PRE_URL,
  TOKEN_KEY,
  BUYER_INFO_KEY,
  JAPAN_MALL_URL,
  VIP_URL,
  SAGAWA_URL,
  LANG_URL,
  I18N_STORAGE_KEY,
  JAPAN_MALL_ORDER_URL,
  VIP_ORDER_URL,
  SAGAWA_ORDER_URL,
}